'use strict';

export default function isEnterOrSpacebarPressed(event) {
    let code = event.keyCode ? event.keyCode : event.which;

    if (code === 13 || code === 32) {
        event.preventDefault();
        return true;
    } else {
        return false;
    }
}